module.exports = __webpack_public_path__ + "files/b04952ea8e88dbc74979efe2a9d0a88b.svg";